import { TypeChecker } from '@attain-apps/type-guards'

import * as ecModels from '../../../models'
import * as plugin from '../../plugin'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Makes request to the API layer to fetch/mutate data. With tracking of the
 * request statuses. (e.g. pending, succeeded, failed)
 */
export class Plugin<
  TTypeParams extends ecModels.TypeParams.Constraint,
> extends plugin.Plugin<
  TTypeParams,
  plugin.Plugin.Id.Standard.ApiExecution,
  State,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig<TTypeParams>>
> {
  public get listQueryRequestUsage():
    | ecModels.Api.list.QueryRequestUsage
    | undefined {
    return (
      this.collection.api.list &&
      ecModels.Api.list.QueryRequestUsage.from(this.collection.api.list)
    )
  }

  constructor({ collection }: Plugin.constructor.Params<TTypeParams>) {
    super({
      actions: getActionsConfig<TTypeParams>(),
      collection,
      id: plugin.Plugin.Id.Standard.ApiExecution,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.feature.registerEffects(effects.executeRequest(collection.api))
  }

  /**
   * Determines if the associated {@link ecModels.Api} has an implementation for
   * the given {@link ecModels.Api.MethodName}
   */
  public canExecute(methodName: ecModels.Api.Method.Name): boolean {
    return TypeChecker.isFunction(this.collection.api[methodName])
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<TTypeParams extends ecModels.TypeParams.Constraint> =
      Pick<plugin.Plugin.Default<TTypeParams>, 'collection'>
  }
}
